/**
 * SCD Lot 0 — Catalogue de contrats B2B transport (SCD) vidé.
 * Les exports sont conservés pour compatibilité avec le moteur de tours,
 * qui devient inerte tant que ces tableaux sont vides.
 * La boucle retail B2C (trafic × conversion × panier moyen) sera
 * implémentée dans les lots suivants via /data/dgs/*.json.
 */
export const CONTRACTS = [];

export const SPECIAL_CONTRACTS = [];

export const getContractsByTier = (maxTier) => CONTRACTS.filter(c => c.tierMin <= maxTier);
export const getContractsByCategory = (cat) => CONTRACTS.filter(c => c.category === cat);
